module.exports = __webpack_public_path__ + "static/media/Artboard4.23814bdb.png";